'use client'

import React, { useEffect, useMemo } from 'react'
import { type RegisterOptions } from 'react-hook-form'

import { normalizeErrorSimple } from '@rewardops/utils/src/form-utils'

import { cn } from '../lib/utils'
import { Input, Label } from '../shad'

export interface InputFieldProps
  extends React.HTMLAttributes<HTMLInputElement> {
  name: string
  placeholder?: string
  label?: string
  type?: string
  disabled?: boolean
  formConsts?: {
    errors?: {
      [key: string]: any
    }
    register: any
    trigger: any
  }
  registerOptions?: RegisterOptions
  initialValue?: string
}

const InputField: React.FC<InputFieldProps> = ({
  name,
  placeholder = 'Type here...',
  label,
  type = 'text',
  disabled = false,
  className,
  formConsts,
  initialValue,
  registerOptions = {},
}: InputFieldProps) => {
  const error = normalizeErrorSimple(name, formConsts?.errors?.[name]?.message)
  const field = useMemo(() => {
    return { ...formConsts?.register(name, registerOptions) }
  }, [formConsts, name, registerOptions])

  useEffect(() => {
    field.onChange({ target: { name, value: initialValue } })
  }, [name])

  return (
    <div
      className={cn('mb-3 w-full', { hidden: type === 'hidden' }, className)}
    >
      <div className="h-full w-full items-center">
        {label ? (
          <Label htmlFor={name} className="mb-1">
            {label}
          </Label>
        ) : undefined}
        <Input
          id={name}
          type={type}
          disabled={disabled}
          placeholder={placeholder}
          aria-label={label ?? placeholder}
          {...formConsts?.register(name, registerOptions)}
        />
        {error ? (
          <p className="mt-2 px-1 text-xs text-red-600">{error}</p>
        ) : undefined}
      </div>
    </div>
  )
}

export { InputField }
